import { memo, useCallback } from "react";
import { Collapse, Paper } from "@mui/material";
import type { CachedTopic } from "@/types/intent";
import { IntentTopicSelector } from "@/components/filters/IntentTopicSelector";
import { EXPORT_INCLUSION_TYPES } from "../types";

const MemoizedIntentTopicSelector = memo(IntentTopicSelector);
MemoizedIntentTopicSelector.displayName = "MemoizedIntentTopicSelector";

export const useIntentTopicRenderer = (
  inclusion: EXPORT_INCLUSION_TYPES,
  selectedTopicIds: string[],
  topicsCache: CachedTopic[],
  onSelectionChange: (ids: string[], cache: CachedTopic[]) => void
) => {
  return useCallback(
    (optionValue: string) => {
      if (optionValue !== EXPORT_INCLUSION_TYPES.SELECTED) return null;

      return (
        <Collapse
          in={inclusion === EXPORT_INCLUSION_TYPES.SELECTED}
          timeout={300}
          unmountOnExit
        >
          <Paper variant="outlined" sx={{ mt: 1, p: 2, mr: 3 }}>
            <MemoizedIntentTopicSelector
              selectedTopicIds={selectedTopicIds}
              topicsCache={topicsCache}
              onSelectionChange={onSelectionChange}
              showUploadDownload={true}
              showToolbarLabel={false}
              mx={0}
            />
          </Paper>
        </Collapse>
      );
    },
    [inclusion, onSelectionChange, selectedTopicIds, topicsCache]
  );
};
